function isStickyColorPrintOptionName(name) {
  const value = String(name || "").toLowerCase();

  return (
    value.includes("color") ||
    value.includes("colour") ||
    value.includes("couleur") ||
    value.includes("farbe") ||
    value.includes("colore") ||
    value.includes("print") ||
    value.includes("impression") ||
    value.includes("druck") ||
    value.includes("stampa")
  );
}

function getStickyColorPrintFieldset(root) {
  if (!root) return null;

  return Array.from(root.querySelectorAll("fieldset")).find((fieldset) => {
    return isStickyColorPrintOptionName(fieldset.getAttribute("option-name"));
  });
}

class StickyVariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", (e) => this.onVariantChange(e));
    this.mainVariantRadio = document.querySelector(".product__info-wrapper variant-radios");
    this.currentTemplate = this.getAttribute("current-template");
    this.preselectColorPrintName();
    this.hideAllSoldoutSwatchRP();
    this.updateMasterId();
    if (this.currentVariant) {
      this.toggleAddButton(!this.currentVariant.available, "", !1);
      this.updateVariantInput();
    } else {
      this.toggleAddButton(!0, "Select a Size", !1);
    }
  }
  preselectColorPrintName() {
    const fieldset = getStickyColorPrintFieldset(this);

    if (!fieldset || fieldset.querySelectorAll("input").length > 1) return;

    const initOption =
      this.options?.[0]?.trim() ??
      this.getAttribute("selected-or-first-available-variant-option-0")?.trim();

    if (!initOption) return;

    this.options = Array.from(this.querySelectorAll("select"), (select) => select.value);
    this.options[0] = initOption;

    const inputs = Array.from(fieldset.querySelectorAll("input"));
    const preselectInput = inputs.find((input) => input.value === initOption);

    if (preselectInput) {
      preselectInput.checked = true;

      const label = preselectInput.nextElementSibling;
      if (label && label.classList) {
        label.classList.add("selected");
      }
    }
  }
  onVariantChange(e) {
    const targetName = e.target?.name ?? "Sticky Color/Print Name";

    this.updateOptions(targetName);
    this.syncToMain(targetName);
    this.updateMasterId();

    if (this.currentVariant) {
      this.toggleAddButton(!this.currentVariant.available, "", false);
      this.updateVariantInput();
    } else {
      this.toggleAddButton(true, "Select a Size", false);
    }
  }
  
  syncToMain(targetName) { if (this.mainVariantRadio) this.mainVariantRadio.sync(this.options, targetName); }
  sync(options, targetName) {
    this.options = options;

    this.syncOptions();
    this.updateOptions(targetName);
    this.updateMasterId();

    if (this.currentVariant) {
      this.updateVariantInput();
      this.toggleAddButton(false, "", false);
    } else {
      this.toggleAddButton(true, "", true);
    }

    if (isStickyColorPrintOptionName(targetName) && this.currentTemplate === "product") {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }
  syncOptions() { const fieldsets = this.querySelectorAll("fieldset"); this.options.forEach((optionValue, index) => { fieldsets[index].querySelectorAll("input").forEach((inputElement) => { inputElement.checked = inputElement.value == optionValue }) }) }
  async updateOptions(targetName) {
    const fieldsets = Array.from(this.querySelectorAll("fieldset")); this.options = fieldsets.map((fieldset) => { return Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked)?.value }); const productHandle = fieldsets[0].getAttribute("product-handle"); const colorOptionCount = [...fieldsets[0].querySelectorAll("input")].length; const response = await fetch(`${window.Shopify.routes.root}products/${productHandle}.js`); const data = await response.json(); const price = document.getElementById(`sticky-price-${this.dataset.section}`); price?.classList.remove("visibility-hidden"); const initVariant = data.variants.find((variant) => { if (this.options[0]) { return variant.option1 === this.options[0] } else { return !0 } }); let tagBasedDiscountPercentage = data.tags.find((tag) => tag.includes("_off"))?.split("_off")[0]; let excludeTagBasedDiscount = data.tags.find((tag) => tag.includes("_off:exclude:")); let excludeTagBasedColor = excludeTagBasedDiscount?.split("_off:exclude:")[1]; tagBasedDiscountPercentage = (100 - tagBasedDiscountPercentage) / 100; let variantHandle = handleize(initVariant.option1);
    const searchParams = new URLSearchParams(window.location.search);
    const colorFieldset = getStickyColorPrintFieldset(this);
    const colorOptionIndex = colorFieldset ? fieldsets.indexOf(colorFieldset) : -1;
    const firstOptionName = fieldsets[0]?.getAttribute("option-name");

    if (colorOptionIndex >= 0 && this.options[colorOptionIndex]) {
      searchParams.set("color-print-name", handleize(this.options[colorOptionIndex]));
    } else {
      searchParams.delete("color-print-name");
    }

    if (this.currentVariant) {
      searchParams.set("variant", this.currentVariant.id);
    }

    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.replaceState({ path: newUrl }, "", newUrl);
    let excludeDiscount = !1; if (variantHandle.includes(excludeTagBasedColor)) { excludeDiscount = !0 }
    const selectedVariant = data.variants.find((variant) => {
      return variant.options.every((option, index) => String(option || "") === String(this.options[index] || ""))
    });
    const pricingVariant = selectedVariant || initVariant;
    let selectedPrice = pricingVariant.price; if (price) {
      const regularPriceElem = price.querySelector(".price-item.price-item--regular"); const salePriceElem = price.querySelector(".price-item.price-item--sale"); regularPriceElem.classList.remove("tag-based-line-through-price"); if (tagBasedDiscountPercentage && !excludeDiscount) { regularPriceElem.classList.add("tag-based-line-through-price") }
      const lineThroughPriceSalePriceRegularElem = price.querySelector(".price__sale .price-item.price-item--regular"); const compareAtPrice = Number(pricingVariant.compare_at_price || 0); const isDiscounted = compareAtPrice > selectedPrice; regularPriceElem.innerHTML = `${currencySymbol}${(selectedPrice / 100).toFixed(2)} ${window.Shopify.currency.active
        }`; salePriceElem.innerHTML = `${currencySymbol}${(selectedPrice / 100).toFixed(2)} ${window.Shopify.currency.active
          }`; if (lineThroughPriceSalePriceRegularElem && isDiscounted) { lineThroughPriceSalePriceRegularElem.textContent = `${currencySymbol}${(compareAtPrice / 100).toFixed(2)} ${window.Shopify.currency.active}` } lineThroughPriceSalePriceRegularElem?.closest(".price-item--regular-wrapper")?.classList.toggle("display-none", !isDiscounted); price.querySelector(".price")?.classList.toggle("price--on-sale", isDiscounted)
      price.querySelector(".tag-based-discount-price")?.remove(); if (tagBasedDiscountPercentage && !excludeDiscount) {
        const salePrice = document.createElement("span"); salePrice.innerHTML = `<span class="price-item price-item--sale tag-based-discount-price">${currencySymbol}${(
          (selectedPrice * tagBasedDiscountPercentage) /
          100
        ).toFixed(2)} ${window.Shopify.currency.active}</span>`; regularPriceElem.insertAdjacentElement("afterend", salePrice)
      }
    }
    const availableVariants = data.variants.filter((variant) => variant.available); const unavailableVariants = data.variants.filter((variant) => !variant.available); let availableSizes = []; let unavailableSizes = []; let unavailableColors = []; if (isStickyColorPrintOptionName(targetName)) {
      if (colorOptionCount === 1) { availableSizes = availableVariants.map((v) => v.option2); unavailableSizes = unavailableVariants.map((v) => v.option2) } else { availableSizes = availableVariants.filter((v) => v.option1 === this.options[0] && v.option2).map((v) => v.option2); unavailableSizes = unavailableVariants.filter((v) => v.option1 === this.options[0] && v.option2).map((v) => v.option2) }
      if (unavailableVariants.length > 0) {
        const labels = [...fieldsets[1].querySelectorAll("label")]; labels.forEach((label) => {
          const textContent = label.textContent.replace(/\s+/g, " ").trim(); if (unavailableSizes.indexOf(textContent) !== -1) { label.classList.add("label-unavailable-styling") } else { label.classList.remove("label-unavailable-styling") }
          if (availableSizes.includes(label.getAttribute("value"))) { label.classList.remove("label-unavailable-styling") }
        })
      }
    } else if (targetName === "Sticky Size") { if (unavailableColors === 1) { unavailableColors = unavailableVariants.map((v) => v.option1) } else { unavailableColors = unavailableVariants.filter((v) => v.option2 === this.options[1] && v.option1).map((v) => v.option1) } } else { }
    const colorSelectedOption = colorFieldset?.querySelector("[selected-option]");
    if (colorSelectedOption && colorOptionIndex >= 0 && this.options[colorOptionIndex]) {
      colorSelectedOption.innerText = this.options[colorOptionIndex]
    }
    if (this.options[0]) {
      if (this.querySelector('span[selected-option="size"][option-pos="1"]')) { this.querySelector('span[selected-option="size"]').innerText = this.options[0] }
    } else { this.options[0] = "Select Color/Print" }
    if (this.options[1]) { this.querySelector('span[selected-option="size"], span[selected-option="taille"], span[selected-option="grosse"], span[selected-option="misurare"]').innerText = this.options[1] }
  }
  updateMasterId() {
    const data = this.getVariantData();

    if (!Array.isArray(data) || !data.length) {
      this.currentVariant = undefined;
      return;
    }

    if (!Array.isArray(this.options)) {
      this.options = [];
    }

    const hasMissingRequiredOption = data[0].options.some((option, index) => {
      return option !== null && option !== undefined && !this.options[index];
    });

    if (hasMissingRequiredOption) {
      this.currentVariant = undefined;
      return;
    }

    this.currentVariant = data.find((variant) => {
      return variant.options.every((option, index) => {
        return String(this.options[index] || "") === String(option || "");
      });
    });
  }
  updateVariantInput() { const productForms = document.querySelectorAll(`#sticky-product-form`); productForms.forEach((productForm) => { const input = productForm.querySelector('input[name="id"]'); input.value = this.currentVariant.id; input.dispatchEvent(new Event("change", { bubbles: !0 })) }) }
  toggleAddButton(disable = !0, text, modifyClass = !0) {
    const productForm = document.getElementById(`sticky-product-form`); if (!productForm) return; const addButton = productForm.querySelector('[name="add"]'); const notifyButton = productForm.querySelector(".klaviyo-bis-trigger"); const addButtonText = productForm.querySelector('[name="add"] > span'); if (!addButton) return; if (disable) { addButton.setAttribute("disabled", "disabled"); if (text) { addButtonText.textContent = text } else { addButtonText.textContent = "Select Size" } } else { addButton.removeAttribute("disabled"); addButtonText.textContent = window.variantStrings.addToCart; addButton.style.display = "flex" }
    if (!modifyClass) return
  }
  getVariantData() { this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent); return this.variantData }
  hideAllSoldoutSwatchRP() {
    const relatedProductSwatches = this.querySelectorAll(".additional-swatch__item"); if (!relatedProductSwatches || relatedProductSwatches.length === 0) { return }
    setTimeout(() => { relatedProductSwatches.forEach((swatch) => { if (!swatch) return; const itemWrapper = swatch.querySelector(".item-wrapper"); if (!itemWrapper) return; const child = itemWrapper.firstElementChild; if (!child) { swatch.remove() } }) }, 500)
  }
}
customElements.define("sticky-variant-radios", StickyVariantRadios)
